<template>
  <div class="row">
    <div class="col-md-12">
      <form>
        <div slot="header" class="pt-5" v-if="user.type === 'gaa'">
          <h3>{{shopName}} - 加值服務管理</h3>
        </div>
        <card v-if="user.type === 'gaa'">
          <h5>
            加值服務啟用
          </h5>
          <div class="row">
            <div class="col-md-4">
              <h6>寄杯券服務串接</h6>
              <div v-if="!services.life17">
                <div class="row">
                  <div class="col-sm-12">
                    <p class="card-text">
                      <!-- <p>{{qcDomain.life17ShoppingUrl}}</p> -->
                      <fg-input id="_17-life-shopping-url" :value="qcDomain.life17ShoppingUrl"
                        required
                        name="life17ShoppingUrl"
                        >
                      </fg-input>

                      <!-- <input type="hidden" id="_17-life-shopping-url" :value="qcDomain.life17ShoppingUrl"> -->
                      <el-button
                        type="primary"
                        size="mini"
                        icon="el-icon-plus"
                        class="ml-2"
                        round
                        v-on:click="copy17LifeShoppingUrl()"
                        v-if="!services.life17"
                      >複製到剪貼簿</el-button>
                      <!-- <button @click="copy17LifeShoppingUrl()">複製</button><br /> -->
                      
                      <div class="row">
                        <div class="col-md-12">
                        <b>請將上方網址建立成LIFF ID後，填入下方欄位後啟用服務</b>
                        <fg-input placeholder="LIFFID"
                        required
                        v-model="inputData.life17.liffId"
                        name="life17LiffId"
                        >
                        </fg-input>
                        </div>
                      </div>
                      
                    </p>
                  </div>
                </div>
              </div>
              <div v-if="services.life17">
                <ul>
                  <li>服務已啟用</li>
                  <li>17Life商店ID：{{services.life17.life17StoreId}} </li>
                  <li>啟用時間：{{services.life17.createdAt}}</li>
                </ul>
                <b>請將下方網址設定到Richmenu寄杯券購買按鈕</b>
                <fg-input id="_17-life-shopping-liff-url" :value="qcDomain.life17ShoppingLiffUrl"
                  required
                  name="life17ShoppingLiffUrl"
                  >
                </fg-input>
                <el-button
                  type="primary"
                  size="mini"
                  icon="el-icon-plus"
                  class="ml-2"
                  round
                  v-on:click="copy17LifeShoppingLiffUrl()"
                  v-if="services.life17"
                >複製到剪貼簿</el-button>
              </div>
              <el-button
                type="primary"
                size="small"
                icon="el-icon-plus"
                class="ml-2"
                round
                v-on:click="enable17Life()"
                v-if="!services.life17"
              >啟用17Life寄杯券服務</el-button>
            </div>
            <div class="col-md-4">
              <h6>TTPush 台東金幣</h6>
              <div v-if="services.ttpush">
                <ul>
                  <li>服務已啟用</li>
                  <li>設定ID：{{services.ttpush.merchantId}} </li>
                  <li>啟用時間：{{services.ttpush.createdAt}}</li>
                </ul>
                <b>請將下方網址設定到TTPush後台</b>
                <fg-input id="_ttpush-url" :value="qcDomain.ttpushUrl"
                  required
                  name="ttpushUrl"
                  >
                </fg-input>
                <el-button
                  type="primary"
                  size="mini"
                  icon="el-icon-plus"
                  class="ml-2"
                  round
                  v-on:click="copyTTPushUrl()"
                  v-if="services.ttpush"
                >複製到剪貼簿</el-button>
              </div>
              <el-button
                type="primary"
                size="small"
                icon="el-icon-plus"
                class="ml-2"
                round
                v-on:click="enableTTPush()"
                v-if="!services.ttpush"
              >啟用TTPush點數服務</el-button>
            </div>
            <div class="col-md-4">
              <h6>APP串接網址</h6>
              <div>
                <p>WEMO</p>
                <fg-input id="_wemo-url" :value="qcDomain.wemoUrl"
                  required
                  name="wemoUrl"
                  >
                </fg-input>
                <el-button
                  type="primary"
                  size="mini"
                  icon="el-icon-plus"
                  class="ml-2"
                  round
                  v-on:click="copyWemoUrl()"
                >複製到剪貼簿</el-button>
              </div>
            </div>
          </div>
        </card>
        <div slot="header" class="pt-5" >
          <h3>{{shopName}} - 設定第三方串接</h3>
        </div>
        <card v-for="(item, index) in settings">
          
          <h4 class="card-title">{{displayedName[item.vendorCode] ? displayedName[item.vendorCode] : item.vendorCode}}</h4>
          <div class="text-right" v-if="user.type === 'gaa'">
            <el-button
              type="danger"
              size="small"
              icon="el-icon-delete"
              class="ml-2"
              round
              v-on:click="del(item)"
            >刪除此設定</el-button>
          </div>
          <p v-if="item.id">串接設定ID: {{item.id}}</p>
          <div class="row" v-if="user.type === 'gaa'">
            <label class="col-sm-2 col-form-label">選擇串接類型</label>
            <div class="col-sm-10 checkbox-radios">
              <radio label="ubereats" v-model="item.vendorCode">Ubereats Pro (上傳菜單+訂單)</radio>
              <!-- <radio label="ubereats-menus" v-model="item.vendorCode" >Ubereats (基底菜單)</radio> -->
              <radio label="foodpanda" v-model="item.vendorCode">Foodpanda Pro (上傳菜單+訂單)</radio>
              <radio label="ubereats-lite" v-model="item.vendorCode">Ubereats Lite</radio>
              <radio label="foodpanda-lite" v-model="item.vendorCode">Foodpanda Lite</radio>
              <radio label="lafresh" v-model="item.vendorCode">益欣 (基底菜單+訂單)</radio>
              <radio label="geoshop" v-model="item.vendorCode">社守 (基底菜單+訂單)</radio>
              <radio label="gofoodie" v-model="item.vendorCode">Gofoodie</radio>
              <radio label="counter" v-model="item.vendorCode">IDOO</radio>
              <radio label="linespot" v-model="item.vendorCode">Line Spot</radio>
              <!-- <radio label="1" v-model="radios.radio1" inline>First Radio</radio> -->
              <!-- <radio label="2" v-model="radios.radio1" inline>Second Radio</radio> -->
            </div>
          </div>
          <div class="row" v-if="user.type === 'si' && vendors && vendors.length">
            <label class="col-sm-2 col-form-label">選擇串接類型</label>
            <div class="col-sm-10 checkbox-radios">
              <template v-for="(v, index) in vendors">
                <radio :label="v.vendorCode" v-model="item.vendorCode">{{displayedName[v.vendorCode]}}</radio>
              </template>
              
            </div>
          </div>
          <!-- <div class="row">
            <label class="col-sm-2 col-form-label">串接環境類型</label>
            <div class="col-sm-10 checkbox-radios">
              <radio label="production" v-model="item.env">Production</radio>
              <radio label="staging" v-model="item.env" v-if="item.vendorCode === 'lafresh' || item.vendorCode === 'geoshop'">Sandbox</radio>
            </div>
          </div> -->
          <div class="row">
            <label class="col-sm-2 col-form-label"> {{vendorShopIdTitle[item.vendorCode]}}</label>
             
            <div class="col-md-8">
              <fg-input :placeholder="vendorShopIdPlaceHolder[item.vendorCode]"
              required
              v-model="item.vendorShopId"
              name="vendorShopId"
              :disabled="vendorShopIdDisabled[item.vendorCode]"
              >
              </fg-input>
            </div>
          </div>
          <div class="row" v-if="(item.vendorCode !== 'lafresh')">
            <label class="col-sm-2 col-form-label">串接Key設定</label>
            <div class="col-sm-10 checkbox-radios">
              <checkbox v-model="item.authData.useDefault">使用預設帳號</checkbox>
            </div>
          </div>
          <div class="row" v-if="(item.vendorCode === 'ubereats' || item.vendorCode === 'ubereats-menus' || item.vendorCode === 'ubereats-lite') && !item.authData.useDefault">
            <label class="col-sm-2 col-form-label">Client ID</label>
            <div class="col-md-8">
              <fg-input
              required
              v-model="item.authData.clientId"
              name="vendorAuthDataId"
              >
              </fg-input>
            </div>
          </div>
          <div class="row" v-if="(item.vendorCode === 'ubereats' || item.vendorCode === 'ubereats-menus' || item.vendorCode === 'ubereats-lite') && !item.authData.useDefault">
            <label class="col-sm-2 col-form-label">Client Secret (可勾選預設用點點帳號)</label>
            <div class="col-md-8">
              <fg-input
              required
              v-model="item.authData.clientSecret"
              name="vendorAuthDataSecret"
              >
              </fg-input>
            </div>
          </div>
          <div class="row" v-if="(item.vendorCode === 'foodpanda' || item.vendorCode === 'foodpanda-lite') && !item.authData.useDefault">
            <label class="col-sm-2 col-form-label">Username (可勾選預設用點點帳號)</label>
            <div class="col-md-8">
              <fg-input 
              required
              v-model="item.authData.username"
              name="vendorAuthDataId"
              >
              </fg-input>
            </div>
          </div>
          <div class="row" v-if="(item.vendorCode === 'foodpanda' || item.vendorCode === 'foodpanda-lite') && !item.authData.useDefault">
            <label class="col-sm-2 col-form-label">Password (可勾選預設用點點帳號)</label>
            <div class="col-md-8">
              <fg-input
              required
              v-model="item.authData.password"
              name="vendorAuthDataSecret"
              >
              </fg-input>
            </div>
          </div>
          <div class="row" v-if="(item.vendorCode === 'foodpanda' || item.vendorCode === 'foodpanda-lite')">
            <label class="col-sm-2 col-form-label">Chain Code (預設填入 dotdotchain)</label>
            <div class="col-md-8">
              <fg-input :placeholder="somecode"
              required
              v-model="item.options.chainCode"
              name="vendorOptionId"
              >
              </fg-input>
            </div>
          </div>
          <div class="row" v-if="(item.vendorCode === 'foodpanda' || item.vendorCode === 'foodpanda-lite')">
            <label class="col-sm-2 col-form-label">Vendor ID (打跟商店ID一樣)</label>
            <div class="col-md-8">
              <fg-input :placeholder="9999"
              required
              v-model="item.options.chainVendorId"
              name="vendorOptionId"
              >
              </fg-input>
            </div>
          </div>
          <div class="row" v-if="(item.vendorCode === 'ubereats' || item.vendorCode === 'ubereats-menus' || item.vendorCode === 'ubereats-lite' || item.vendorCode === 'foodpanda' || item.vendorCode === 'foodpanda-lite')">
            <label class="col-sm-2 col-form-label">樣板ID</label>
            <div class="col-md-8">
              <fg-input
              required
              v-model="item.options.templateId"
              name="vendorTemplateId"
              >
              </fg-input>
            </div>
          </div>
          <div class="row" v-if="(item.vendorCode === 'gofoodie' || item.vendorCode === 'counter')">
            <label class="col-sm-2 col-form-label">內用樣板ID</label>
            <div class="col-md-8">
              <fg-input
              required
              v-model="item.options.eatInTemplateId"
              name="vendorTemplateEatInId"
              >
              </fg-input>
            </div>
          </div>
          <div class="row" v-if="(item.vendorCode === 'gofoodie' || item.vendorCode === 'counter')">
           <label class="col-sm-2 col-form-label">自取樣板ID</label>
            <div class="col-md-8">
              <fg-input
              required
              v-model="item.options.togoTemplateId"
              name="vendorTemplateTogoId"
              >
              </fg-input>
            </div>
          </div>
          <div class="row" v-if="(item.vendorCode === 'gofoodie' || item.vendorCode === 'counter')">
          <label class="col-sm-2 col-form-label">外送樣板ID</label>
            <div class="col-md-8">
              <fg-input
              required
              v-model="item.options.deliveryTemplateId"
              name="vendorTemplateDeliveryId"
              >
              </fg-input>
            </div>
          </div>
          <div class="row" v-if="item.vendorCode === 'geoshop' && !item.authData.useDefault">
            <label class="col-sm-2 col-form-label">Account (可勾選預設用點點帳號)</label>
            <div class="col-md-8">
              <fg-input 
              required
              v-model="item.authData.account"
              name="vendorAuthDataSecret"
              >
              </fg-input>
            </div>
          </div>
          <div class="row" v-if="item.vendorCode === 'geoshop' && !item.authData.useDefault">
            <label class="col-sm-2 col-form-label">Password (可勾選預設用點點帳號)</label>
            <div class="col-md-8">
              <fg-input 
              required
              v-model="item.authData.password"
              name="vendorAuthDataPassword"
              >
              </fg-input>
            </div>
          </div>
          <div class="row" v-if="item.vendorCode === 'lafresh'">
            <label class="col-sm-2 col-form-label">分店ID</label>
            <div class="col-md-8">
              <fg-input 
              required
              v-model="item.authData.shopId"
              @change="changeLafreshShopId(item)"
              name="vendorAuthDataShopId"
              >
              </fg-input>
            </div>
          </div>
          <div class="row" v-if="item.vendorCode === 'lafresh'">
            <label class="col-sm-2 col-form-label">Auth Key</label>
            <div class="col-md-8">
              <fg-input 
              required
              v-model="item.authData.authkey"
              @change="changeLafreshShopId(item)"
              name="vendorAuthDataAuthkey"
              >
              </fg-input>
            </div>
          </div>
          <div class="row" v-if="item.vendorCode === 'lafresh'">
            <label class="col-sm-2 col-form-label">Access Key (預設請填：67pcbag9awwfdxe19gdj1rgfb2xvny9c)</label>
            <div class="col-md-8">
              <fg-input placeholder="67pcbag9awwfdxe19gdj1rgfb2xvny9c" 
              required
              v-model="item.authData.acckey"
              name="vendorAuthDataAcckey"
              >
              </fg-input>
            </div>
          </div>
           <div class="row" v-if="item.vendorCode === 'lafresh'">
            <label class="col-sm-2 col-form-label">Endpoint</label>
            <div class="col-md-8">
              <fg-input placeholder="http://omni.lafresh.com.tw" 
              required
              v-model="item.authData.endpoint"
              name="vendorEndpoint"
              >
              </fg-input>
            </div>
          </div>
          <div class="row" v-if="(item.vendorCode === 'lafresh')">
            <label class="col-sm-2 col-form-label">菜單同步訊息通知Email(用逗號分隔)</label>
            <div class="col-md-8">
              <fg-input placeholder="user@example.com,user2@example.com"
              required
              v-model="item.options.syncMenuNotify"
              name="syncMenuNotify"
              >
              </fg-input>
            </div>
          </div>
          <!-- <div class="row" v-if="(item.vendorCode === 'lafresh')">
            <label class="col-sm-2 col-form-label">類型 (前結： EC_QUICK_ORDER, 後結：掃碼下單)</label>
            <div class="col-md-8">
              <fg-input :placeholder="EC_QUICK_ORDER"
              required
              v-model="item.options.clientDevice"
              name="vendorClientDevice"
              >
              </fg-input>
            </div>
          </div>
          <div class="row" v-if="(item.vendorCode === 'lafresh')">
            <label class="col-sm-2 col-form-label">Banner Type (前結：CATERING, 後結：掃碼下單)</label>
            <div class="col-md-8">
              <fg-input :placeholder="CATERING"
              required
              v-model="item.options.bannerType"
              name="vendorBannerType"
              >
              </fg-input>
            </div>
          </div> -->
          <div class="row" v-if="(item.vendorCode === 'ubereats-lite' || item.vendorCode === 'foodpanda-lite')">
            <label class="col-sm-2 col-form-label">加購列印樣式 - 直列(straight)/橫列(row) (預設橫列)</label>
            <div class="col-md-8">
              <fg-input placeholder="straight"
              required
              v-model="item.options.qpPrinterOptionType"
              name="qpPrinterOptionType"
              >
              </fg-input>
            </div>
          </div>
           
          <div class="d-flex justify-content-center">
            <el-button
              type="warning"
              size="small"
              icon="el-icon-plus"
              class="ml-2"
              round
              v-on:click="save(item)"
            >儲存此設定</el-button>
          </div>
       
           
        </card>
         <el-button v-if="user.type === 'gaa' || (user.type === 'si' && vendors && vendors.length)"
          type="primary"
          size="small"
          icon="el-icon-plus"
          class="ml-2"
          round
          v-on:click="add()"
        >新增串接設定</el-button>
      </form>
    </div>
  </div>

</template>

<script>
import moment from "moment";
import axios from "axios";
import { Checkbox, Radio } from 'src/components/index';

export default {
  components: {
    Checkbox,
    Radio
  },
  data() {
    return {
      shopName: "",
      vendorShopIdTitle: {
        "ubereats": "Ubereats UUID",
        // "ubereats-menus": "Ubereats UUID",
        "ubereats-lite": "Ubereats UUID",
        "foodpanda": "(TW-) + 餐廳Code",
        "foodpanda-lite": "(TW-) + 餐廳Code",
        "lafresh": "Shop ID與Auth Key",
        "geoshop": "Store Email",
        "gofoodie": "Gofoodie商店ID (P_xxxxx)",
        "counter": "本店ID (數字)",
        "linespot": "本店ID (數字)"
      },
      vendorShopIdDisabled: {
        "lafresh": true
      },
      vendorShopIdPlaceHolder: {
        "ubereats": "d5f0fe82-374b-47ee-85d6-5fd825d1d52c",
        // "ubereats-menus": "d5f0fe82-374b-47ee-85d6-5fd825d1d52c",
        "ubereats-lite": "d5f0fe82-374b-47ee-85d6-5fd825d1d52c",
        "foodpanda": "TW-abcd",
        "foodpanda-lite": "TW-abcd",
        "lafresh": "001@abcdefghijklmnopqrstuvwxyz",
        "geoshop": "demo@quickclick.cc",
        "gofoodie": "P_xxxxx",
        "counter": "1",
        "linespot": "1"
      },
      displayedName: {
        "ubereats": "UberEats Pro",
        // "ubereats-menus": "d5f0fe82-374b-47ee-85d6-5fd825d1d52c",
        "ubereats-lite": "UberEats Lite",
        "foodpanda": "Foodpanda Pro",
        "foodpanda-lite": "Foodpanda Lite",
        "lafresh": "Lafresh 益欣",
        "geoshop": "Geoshop 射手",
        "gofoodie": "Gofoodie",
        "counter": "IDOO 愛點餐飲",
        "linespot": "LINE熱點"
      },
      settings: [],
      vendors: [],
      services: {
        life17: false,
        ttpush: false
      },
      qcDomain: {
        life17ShoppingLiffUrl: null,
        webhookUrlDomain: null,
        qpointsUrl: null,
        ttpushUrl: null,
        wemoUrl: null,
        token: null
      },
      inputData: {
        life17: {
          liffId: ''
        }
      }
    }
  },
  mounted() {
    this.shopName = this.$route.query.shop_name;
    this.getServiceUrls();
    this.get();
    this.getServices();
    if (this.user.type === 'si') {
      this.getVendors();
    }
  },
  methods: {
    changeLafreshShopId(mwData) {
      mwData.vendorShopId = mwData.authData.shopId + '@' + mwData.authData.authkey;
    },
    getServiceUrls() {
      axios.get(`${process.env.VUE_APP_APIHOST}/${this.user.type}/shops/${
              this.$route.query.shop_id
            }/service-urls`)
      .then((response) => {
        let account = response.data;
        
        if (account && account.webhookUrlDomain)
          this.qcDomain.webhookUrlDomain = account.webhookUrlDomain;

        if (account && account.life17ShoppingLiffUrl)
          this.qcDomain.life17ShoppingLiffUrl = account.life17ShoppingLiffUrl;

        if (account && account.qpointsUrl) {
          this.qcDomain.qpointsUrl = account.qpointsUrl;
          this.qcDomain.ttpushUrl = account.qpointsUrl + '&source=ttpush';
          this.qcDomain.wemoUrl = account.qpointsUrl + '&source=wemo';
        }

        this.qcDomain.life17ShoppingUrl = `https://${this.qcDomain.webhookUrlDomain}/line/views/auth/pick-up`;

        if (account && account.token)
          this.qcDomain.token = account.token;
      })
      .catch((e) => {
        console.error(e.stack);
      })
    },
    get() {
      axios.get(`${process.env.VUE_APP_APIHOST}/${this.user.type}/shops/${
              this.$route.query.shop_id
            }/mw-settings`)
      .then((response) => {
        let rows = response.data;
        console.log('get response settings ', rows);
        for (let posSetting of rows) {
          if (!posSetting.options)
            posSetting.options = {};

          if (!posSetting.authData) {
            posSetting.authData = {};
            posSetting.authData.useDefault = true;
          }
            
        }

        this.settings = rows;
      })
      .catch((e) => {
        console.error(e.stack);
      })
    },
    add() {
      if (this.user.type === 'si' && this.vendors && this.vendors.length) {
        this.settings.push(
          {
            "vendorCode": this.vendors[0].vendorCode,
            "env": "production",
            "authData": {
              // "useDefault": true
            },
            "options": {}
          }
        )
      } else {
        this.settings.push(
          {
            "vendorCode": "ubereats",
            "env": "production",
            "authData": {
              // "useDefault": true
            },
            "options": {}
          }
        )
      }
      
    },
    save(item) {
      let self = this;
      if (!item)
        item = {};

      let id = item.id;

      if (item.authData && item.authData.useDefault)
        item.authData = null;

      // 移除空值
      if (item.authData) {
        for (let key in item.authData) {
          if (typeof item.authData[key] === 'string' && !item.authData[key]) {
            delete item.authData[key];
          }
        }
      }
      if (item.options && item.options.templateId) {
        try {
          let numTemplateId = parseInt(item.options.templateId, 10); // templateId比較嚴謹，一定要數字
          item.options.templateId = numTemplateId;
        } catch (e) {
          delete item.options.templateId;
        }

        for (let key in item.options) {
          if (typeof item.options[key] === 'string' && !item.options[key]) {
            delete item.options[key];
          }
        }
      }

      // {"templateFormulas":[{"derivation":"{{IF(mealType === 'eatIn', 1, 0)}}","name":"isEatIn","function":"eval"},{"derivation":"{{IF(mealType === 'toGo', 1, 0)}}","name":"isToGo","function":"eval"},{"derivation":"{{IF(mealType === 'delivery', 1, 0)}}","name":"isDelivery","function":"eval"},{"derivation":"{{(formulaResults.isEatIn * 12) || (formulaResults.isToGo * 12) || (formulaResults.isDelivery * 14)}}","name":"templateId","function":"eval"}]}

      if (item.options && item.options.eatInTemplateId && item.options.togoTemplateId && item.options.deliveryTemplateId) {
        item.options.templateFormulas = [{"derivation":"{{IF(mealType === 'eatIn', 1, 0)}}","name":"isEatIn","function":"eval"},{"derivation":"{{IF(mealType === 'toGo', 1, 0)}}","name":"isToGo","function":"eval"},{"derivation":"{{IF(mealType === 'delivery', 1, 0)}}","name":"isDelivery","function":"eval"},{"derivation":`{{(formulaResults.isEatIn * ${item.options.eatInTemplateId}) || (formulaResults.isToGo * ${item.options.togoTemplateId}) || (formulaResults.isDelivery * ${item.options.deliveryTemplateId})}}`,"name":"templateId","function":"eval"}];
      } else {
        delete item.options.templateFormulas;
      }
 

      if (id) {
        axios.put(`${process.env.VUE_APP_APIHOST}/${this.user.type}/shops/${
              this.$route.query.shop_id
            }/mw-settings/${id}`, 
        item)
        .then((response) => {
          self.get();
        })
      } else { // new
        axios.post(`${process.env.VUE_APP_APIHOST}/${this.user.type}/shops/${
              this.$route.query.shop_id
            }/mw-settings`, 
        item)
        .then((response) => {
          self.get();
        })
      }
      
    },
    del(item) {
      let self = this;
      if (item && item.id) {
        console.log('request delete');
        axios.delete(`${process.env.VUE_APP_APIHOST}/${this.user.type}/shops/${
              this.$route.query.shop_id
            }/mw-settings/${item.id}`, 
        item)
        .then((response) => {
          self.get()
        })
      } else {
        self.get()
      }
    },
    copy17LifeShoppingUrl() {
      let textToCopy = document.querySelector("#_17-life-shopping-url");
      // textToCopy.setAttribute('type', 'text');
      textToCopy.select();
      var successful = document.execCommand("copy");
      // textToCopy.setAttribute('type', 'hidden');
      if(successful){
        this.$message({
          type: 'success', message: `已複製`
        });
      } else {
        this.$message({
          type: 'warning', message: `錯誤`
        });
      }
    },
    copy17LifeShoppingLiffUrl() {
      let textToCopy = document.querySelector("#_17-life-shopping-liff-url");
      // textToCopy.setAttribute('type', 'text');
      textToCopy.select();
      var successful = document.execCommand("copy");
      // textToCopy.setAttribute('type', 'hidden');
      if(successful){
        this.$message({
          type: 'success', message: `已複製`
        });
      } else {
        this.$message({
          type: 'warning', message: `錯誤`
        });
      }
    },
    copyTTPushUrl() {
      let textToCopy = document.querySelector("#_ttpush-url");
      // textToCopy.setAttribute('type', 'text');
      textToCopy.select();
      var successful = document.execCommand("copy");
      // textToCopy.setAttribute('type', 'hidden');
      if(successful){
        this.$message({
          type: 'success', message: `已複製`
        });
      } else {
        this.$message({
          type: 'warning', message: `錯誤`
        });
      }
    },
    copyWemoUrl() {
      let textToCopy = document.querySelector("#_wemo-url");
      // textToCopy.setAttribute('type', 'text');
      textToCopy.select();
      var successful = document.execCommand("copy");
      // textToCopy.setAttribute('type', 'hidden');
      if(successful){
        this.$message({
          type: 'success', message: `已複製`
        });
      } else {
        this.$message({
          type: 'warning', message: `錯誤`
        });
      }
    },
    enable17Life() {
      let self = this;
      axios.post(`${process.env.VUE_APP_APIHOST}/${this.user.type}/shops/${
            this.$route.query.shop_id
          }/services/life17`, 
      {
        liffId: this.inputData.life17.liffId
      })
      .then((response) => {
        // self.get();
        self.getServices();
      })
    },
    enableTTPush() {
      let self = this;
      axios.post(`${process.env.VUE_APP_APIHOST}/${this.user.type}/shops/${
            this.$route.query.shop_id
          }/services/ttpush`, 
      {})
      .then((response) => {
        // self.get();
        self.getServices();
      })
    },
    getVendors() {
      axios.get(`${process.env.VUE_APP_APIHOST}/${this.user.type}/mw-vendors`)
      .then((response) => {
        let rows = response.data;
        console.log('get response settings ', rows);
        // for (let posSetting of rows) {
        //   if (!posSetting.options)
        //     posSetting.options = {};

        //   if (!posSetting.authData) {
        //     posSetting.authData = {};
        //     posSetting.authData.useDefault = true;
        //   }
            
        // }

        this.vendors = rows;
      })
      .catch((e) => {
        console.error(e.stack);
      })
    },
    getServices() {
      let self = this;
      axios.get(`${process.env.VUE_APP_APIHOST}/${this.user.type}/shops/${
            this.$route.query.shop_id
          }/services`, 
      {})
      .then((response) => {
        // self.get();
        if (response.data && response.data.life17) {
          response.data.life17.createdAt = moment.unix(response.data.life17.createdTs).format('YYYY-MM-DD HH:mm:ss');
        }
        if (response.data && response.data.ttpush) {
          response.data.ttpush.createdAt = moment.unix(response.data.ttpush.createdTs).format('YYYY-MM-DD HH:mm:ss');
        }
        this.services = response.data;
        console.log(response.data);
        
      })
    }
  },
  computed: {
    user: function() {
      return this.$store.getters.user;
    }
  }
}
</script>